import { FC } from "react";
import { Link } from "react-router-dom";
import { Anchor, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { CodeVerificationForm } from "../../features/code-verification/CodeVerificationForm";
import useAuthStore from "../../store/useAuthStore";

interface Props {
  onContinue: () => void;
}

export const CodeVerificationWidget: FC<Props> = ({ onContinue }) => {
  const { t } = useTranslation();
  const { user } = useAuthStore();

  return (
    <Stack align="stretch" justify="center" gap="24px">
      <Title size={36}>{t("code_verification")}</Title>
      <Text c="dimmed" size="md">
        {t("verification_code_sent")}
        <span style={{ textDecoration: "underline" }}>{user?.email}</span>
        {t("verification_code_sent2")}
      </Text>
      <CodeVerificationForm onContinue={onContinue} />
      <Anchor
        c="dimmed"
        to="/login/sign-in"
        underline="always"
        component={Link}
      >
        {t("back_to_sign_up")}
      </Anchor>
    </Stack>
  );
};
